import { useI18n } from 'i18n-utils'
import { useStaticTableDataStore, useUserInfoStore } from 'store'
import { DefineComponentProps, requestIdleCallbackFrame } from 'utils'
import './AssetCell.scss'
type AssetCellProps = {
  asset: ApiResponse.RemainAssetListItem
  /** 是否是持仓列表 */
  isHoldingList?: boolean
}

export const AssetCell = defineComponent<AssetCellProps>({
  name: 'AssetCell',
  props: DefineComponentProps<AssetCellProps>(['asset', 'isHoldingList']),
  setup(props) {
    const { t } = useI18n()
    const staticTableStore = useStaticTableDataStore()
    const userInfoStore = useUserInfoStore()

    const isRender = ref(false)
    const handleRender = () => {
      requestIdleCallbackFrame(() => {
        isRender.value = true
      })
    }
    onBeforeMount(() => {
      handleRender()
    })
    return () => {
      if (isRender.value) {
        const itemInfo = staticTableStore.getItemInfoByItemId(props.asset.itemId)
        const asset = props.asset

        return (
          <div class={'asset-cell-layout mobile-asset-item'}>
            <div class="mobile-asset-item-name">
              <img width={24} src={itemInfo?.itemDetail.coinUrl} alt="" />
              <div class="mobile-asset-item-name-info">
                <div class="all name-item">
                  <span class="name">{itemInfo?.itemName?.toUpperCase()}</span>
                  <span class="value">{asset.all.removeTrailingZero.decimalPadZero(2).formatNumberWithCommas()}</span>
                </div>
                <div class="cny name-item">
                  <span class="name">{itemInfo?.itemDetail.explain?.toUpperCase()}</span>
                  <span class="value">
                    {asset.valuation.removeTrailingZero.isGreaterThan(0) ? '≈' : null}
                    {userInfoStore.moneyMark}
                    {asset.valuation.removeTrailingZero.decimalPadZero(2).formatNumberWithCommas()}
                  </span>
                </div>
              </div>
            </div>
            {/* 可用 */}
            <div class="mobile-asset-item-amount">
              <span class="mobile-asset-item-amount-title">{t('可用')}</span>
              <span class="mobile-asset-item-amount-value">{asset.over.removeTrailingZero.decimalPadZero(2).formatNumberWithCommas()}</span>
            </div>
            {/* 冻结 */}
            <div class="mobile-asset-item-amount">
              <span class="mobile-asset-item-amount-title">{t('冻结')}</span>
              <span class="mobile-asset-item-amount-value">{asset.lock.removeTrailingZero.decimalPadZero(2).formatNumberWithCommas()}</span>
            </div>
          </div>
        )
      }
      return null
    }
  },
})
